import FieldsFactory from 'components/form/FieldsFactory'
import {FormActionGroups} from 'components/form/FormActionBar'
import {createSelectValue} from 'components/form/utils'
import {Formik} from 'formik'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import withTranslate from 'modules/local/withTranslate'
import React, {useMemo, useState} from 'react'
import {compose, mapProps, pure} from 'recompose'
import {ErrorSummaries} from 'views/AppLocals/factory/createEditableForm'
import {NullAsDefault, renderIf, shallowDiff} from 'views/Shared'
import FormActionBar from '../../../../components/form/FormActionBar'
import {createControlledFormField} from '../../factory/createFormField'
import TextArea from "antd/lib/input/TextArea";
import Pure from "../../../../components/Pure";
import {ActionModalWrapper} from "../../../../components/form/ActionModalWrapper";
import {SelectWidget} from "../../custom/ReactSelectComponents";
import ImgCrop from "antd-img-crop";
import {Checkbox, Image, Upload} from "antd";
import {callApi} from "../../../../modules/asyncCache/callApi";
import {image_directDestroy_Api, image_directUpload_Api} from "../../../../apis";
import {bindQueryParam, bindQueryParams} from "../../functions/routerHelper";
import {STORAGE_URL} from "../../../../envs/_current/config";
import {useImageActions} from "../../../Workspace/Shop/functions/useImageActions";
import {showDeleteConfirmDialog} from "../../factory/createConfirmDialog";
import CustomButton from "../../custom/CustomButton";
import classNames from "classnames";
import {renderMaskImage} from "../../../../components/renderFunctions/renderMaskImage";
import {BsImages} from "react-icons/bs";


export const formSchema = {
    parent: {
        title: 'catalog parent',
        children: [
            {
                name: 'parent_id',
                component: compose(
                    withTranslate,
                    mapProps(({name, translate, onChange, value, form}) => ({
                        name,
                        allowClear: true,
                        className: 'w-full',
                        value: value || undefined,
                        onChange: (value) => {
                            onChange(createSelectValue('parent_id', value))
                        },
                        placeholder: translate('---Choose One---'),
                        options: _.get(form, 'values.product_catalogs', []).map((e) => ({
                            value: e?.id,
                            label: e?.title,
                        })),
                    })),
                    pure
                )(SelectWidget),
            }
        ],
    },
    title: {
        title: 'category',
        children: [
            {
                name: 'title',
                component: createControlledFormField({
                    placeholder: 'category',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
        ],
    },
    description: {
        title: 'short description',
        children: [
            {
                name: 'description',
                component: createControlledFormField({
                    rows: 5,
                    showCount: true,
                    maxLength: 500,
                    placeholder: 'short description',
                    Component: TextArea,
                    className: 'scrollBarThin',
                }),
            },
        ],
    },

}

export const ProductCatalogFormCreate = ({
                                             shop,
                                             owner_id,
                                             owner_type,
                                             onCancel = NullAsDefault,
                                             onSubmit = NullAsDefault,
                                         }) => {
    const t = useTranslate()

    const validate = (values) => {
        let errors = {}

        const {title} = values ?? {}

        if (!title) {
            errors.title = t('required field')
        }

        return errors
    }

    const {product_catalogs} = shop

    function flattenAndClean(catalogs) {
        return _.flatMap(catalogs, c => {
            const item = _.omit(c, 'children'); // bỏ field children

            return [
                item,
                ...flattenAndClean(c.children || [])
            ];
        });
    }

    const _product_catalogs = flattenAndClean(product_catalogs);

    const initialValues = useMemo(() => {
        return {
            owner_id,
            owner_type,
            title: undefined,
            description: undefined,
            parent_id: undefined,
            product_catalogs: _product_catalogs
        }
    }, [owner_id, owner_type])

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={(values) => {
                const {
                    resetKey,
                    ...rest
                } = values ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                        },
                        _.isUndefined
                    )
                )
            }}>
            <React.Fragment>
                <ActionModalWrapper
                    action={
                        <FormActionGroups
                            submitProps={{
                                label: 'create',
                            }}
                        />
                    }>
                    <div className="flex flex-col gap-3">
                        <Pure>
                            <FieldsFactory
                                formSchema={[
                                    formSchema.parent,
                                    formSchema.title,
                                    formSchema.description,
                                ]}
                            />
                        </Pure>

                    </div>
                </ActionModalWrapper>
            </React.Fragment>
        </Formik>
    )
}

export const ProductCatalogFormEdit = ({
                                           shop,
                                           owner_id,
                                           owner_type,
                                           onCancel = NullAsDefault,
                                           onSubmit = NullAsDefault,
                                           item = {},
                                       }) => {
    const t = useTranslate()
    const [current, setCurrent] = useState('overview')

    const {product_catalogs} = shop

    function flattenAndClean(catalogs) {
        return _.flatMap(catalogs, c => {
            const item = _.omit(c, 'children'); // bỏ field children

            return [
                item,
                ...flattenAndClean(c.children || [])
            ];
        });
    }

    const _product_catalogs = flattenAndClean(product_catalogs);

    const _initialValues = useMemo(() => {
        const {
            ...rest
        } = item ?? {}

        return {
            ...rest,
            owner_id,
            owner_type,
            parent_id: rest?.parent?.id,
            product_catalogs: _product_catalogs
        }
    }, [item, owner_id, owner_type])

    const validate = (values) => {
        let errors = {}
        const {title} = values ?? {}
        if (!title) {
            errors.title = t('required field')
        }
        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={(values) => {
                const changes = shallowDiff(values, _initialValues)
                const {
                    resetKey,
                    owner_id,
                    owner_type,
                    ...rest
                } = changes ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                        },
                        _.isUndefined
                    )
                )
            }}>
            <React.Fragment>
                <ErrorSummaries/>
                <ActionModalWrapper
                    tab={current}
                    action={<FormActionBar submitText="save"/>}
                    onTabChange={(key) => {
                        setCurrent(key)
                    }}
                    tabs={[
                        {
                            key: 'overview',
                            label: 'overview',
                            component: ({child}) => child,
                        },
                        {
                            key: 'photos',
                            label: 'photos',
                            component: () => {

                                return (
                                    <ProductCatalogPhotos productCatalog={item} />
                                )
                            },
                        },
                    ]}>
                    <Pure>
                        <FieldsFactory
                            formSchema={[
                                formSchema.parent,
                                formSchema.title,
                                formSchema.description,
                            ]}
                        />
                    </Pure>
                </ActionModalWrapper>
            </React.Fragment>
        </Formik>
    )
}



const ProductCatalogImageUpload = ({productCatalog, fileList, setFileList, onChange, children}) => {
    const t = useTranslate();

    return (
        <ImgCrop
            rotationSlider
            modalTitle={
                <div className="text-center font-bold text-color-000 tracking-wide">
                    {t('preview and edit photo')}
                </div>
            }
            modalWidth={800}
            aspect={5 / 3}
            modalClassName="custom-modal-img-crop"
            modalOk={t('complete')}
            modalCancel={
                <span className="text-color-200 hover:text-color-000">
                    {t('cancel')}
                </span>
            }>
            <Upload
                accept=".jpg,.jpeg,.png,.webp"
                // multiple={true}
                listType="picture"
                fileList={fileList}
                onChange={onChange}
                customRequest={async ({onSuccess, ...args}) => {
                    const response = await callApi({
                        apiInfo: image_directUpload_Api,
                        values: {
                            'photos[]': args.file,
                        },
                        query: bindQueryParams([
                            {type: 'product_catalog'},
                            {id: productCatalog?.id},
                        ]),
                    })
                    const newFileList = _.map(fileList, (item) =>
                        item.uid === args?.file?.uid
                            ? {
                                ...args?.file,
                                id: _.get(response, 'data.ids.0'),
                                status: 'done',
                                url: (_.get(response, 'data.urls.0') || '').startsWith('http')
                                    ? _.get(response, 'data.urls.0')
                                    : `${STORAGE_URL}/${_.get(response, 'data.urls.0')}`,
                            }
                            : item
                    )
                    setFileList(newFileList)
                }}
                onRemove={async (file) => {
                    const newFileList = fileList.filter((item) => item.uid !== file.uid)
                    setFileList(newFileList)
                    const response = await callApi({
                        apiInfo: image_directDestroy_Api,
                        query: bindQueryParam({id: file.id}),
                    })
                }}
                showUploadList={false}>
                {children}
            </Upload>
        </ImgCrop>
    )
}

const ProductCatalogPhotos = ({productCatalog}) => {
    const t = useTranslate()
    const [fileList, setFileList] = useState(
        _.get(productCatalog, 'photos', []).map((e) => ({
            ...e,
            uid: e.id,
            name: e.id,
            url: e.path,
            status: 'done',
        }))
    )

    const _height = 200

    const {
        onDirectUpload,
        onDirectDelete,
        onMultiDirectDelete,
    } = useImageActions({
        notifyListeners: {
            onCreated: (result, data) => {

            },
            onDeleted: (result, data) => {

            },
            onMultiDeleted: (result, data) => {

            },
        },
    })

    const onChange = ({fileList: newFileList}) => {
        setFileList(newFileList);
    };

    const [selectedFiles, setSelectedFiles] = useState([]);

    // select all ảnh
    const handleSelectAll = () => {
        setSelectedFiles(fileList.map((file) => file.uid));
    };

    // deselect all ảnh
    const handleDeselectAll = () => {
        setSelectedFiles([]);
    };

    // Chọn ảnh để xóa nhiều ảnh cùng lúc
    const handleSelectFile = (file, checked) => {
        setSelectedFiles((prev) =>
            checked ? [...prev, file.uid] : prev.filter((id) => id !== file.uid)
        );
    };

    // Xóa nhiều ảnh cùng lúc
    const handleRemoveSelected = () => {
        showDeleteConfirmDialog({
            translate: t,
            title: 'delete photos',
            message: `${t('are you sure you want to delete photos')} ?`,
            onOk: () => {
                onMultiDirectDelete({ids: selectedFiles.join(",")})
                setFileList((prev) => prev.filter((file) => !selectedFiles.includes(file.uid)));
                setSelectedFiles([]); // Reset danh sách đã chọn
            },
        })
    };


    return (
        <>
            <div className="py-2 render-border-center flex items-center gap-2 overflow-x-auto">

                <ProductCatalogImageUpload {...{productCatalog, fileList, setFileList, onChange}}>
                <CustomButton
                    ift="select-all"
                    color="text-primary"
                    type={selectedFiles.length === fileList.length ? "default" : "primary"}
                    label="create variant"
                    textSize="text-sm"
                />
                </ProductCatalogImageUpload>
                <div className="flex-1" />
                <CustomButton
                    ift="deselect-all"
                    type={selectedFiles.length === 0 ? "default" : "primary"}
                    label="deselect all"
                    textSize="text-sm"
                    onClick={handleDeselectAll}
                />
                {renderIf(
                    selectedFiles.length > 0,
                    <CustomButton
                        ift="delete-all"
                        type="danger"
                        label={
                            selectedFiles.length === fileList.length ? 'delete all' :
                                selectedFiles.length > 0 ? t("delete {n} selected photos", {n: selectedFiles.length}) : 'delete'
                        }
                        textSize="text-sm"
                        onClick={handleRemoveSelected}
                    />
                )}
            </div>
            <Image.PreviewGroup>
                <div className="flex flex-col space-y-6">
                    {fileList.map((file, index) => {
                        return (
                            <div key={index} className="relative">
                                <Image
                                    loading="lazy"
                                    key={index}
                                    src={file.url || file.preview}
                                    style={{minHeight: _height}}
                                    wrapperClassName={classNames("rounded-lg", selectedFiles.includes(file.uid) && 'border border-primary')}
                                    className="object-cover rounded-lg cursor-pointer"
                                    preview={{mask: renderMaskImage()}}
                                />
                                <div
                                    className="absolute top-5 left-5 flex gap-3 flex items-center bg-white-30 shadow-md p-1 rounded-md">
                                    <Checkbox
                                        className="flex cursor-pointer"
                                        onChange={(e) => handleSelectFile(file, e.target.checked)}
                                        checked={selectedFiles.includes(file.uid)}
                                    />
                                </div>
                            </div>
                        )
                    })}
                    <ProductCatalogImageUpload {...{productCatalog, fileList, setFileList, onChange}}>
                        <div style={{height: _height}}
                             className="w-full flex flex-col flex-center gap-1 border border-dashed hover:background-50 rounded-lg text-color-300 hover:text-primary cursor-pointer">
                            <BsImages size={30}/>
                            <span className="font-medium tracking-wide">
                                {t('add photo')}
                            </span>
                        </div>
                    </ProductCatalogImageUpload>

                </div>
            </Image.PreviewGroup>
        </>
    )
}